<template>
  <div class="MenuPage" style="background-color: #0a0a0a;">
    <div class="hero is-bold">
      <div class="hero-body">
        <div class="container">
          <h1 class="title is-1" style="color: white;">OUR MENU</h1>
          <h2 class="subtitle is-6" style="color: white;">
            Wine | Champagne | Liquor | More
          </h2>
        </div>
      </div>
    </div>
    <!-- Menu Content -->
    <div class="section" style="padding-top: 0;">
      <div class="columns is-multiline">
        <div class="column is-3-desktop is-6-tablet is-12-mobile">
          <img src="@/assets/menu/menu-2.jpg" />
        </div>
        <div class="column is-3-desktop is-6-tablet is-12-mobile">
          <img src="@/assets/menu/menu-3.jpg" />
        </div>
        <div class="column is-3-desktop is-6-tablet is-12-mobile">
          <img src="@/assets/menu/menu-4.jpg" />
        </div>
        <div class="column is-3-desktop is-6-tablet is-12-mobile">
          <img src="@/assets/menu/menu-5.jpg" />
        </div>
        <div class="column is-3-desktop is-6-tablet is-12-mobile">
          <img src="@/assets/menu/menu-6.jpg" />
        </div>
        <div class="column is-3-desktop is-6-tablet is-12-mobile">
          <img src="@/assets/menu/menu-1.jpg" />
        </div>
        <div class="column is-3-desktop is-6-tablet is-12-mobile">
          <img src="@/assets/menu/menu-7.jpg" />
        </div>
        <div class="column is-3-desktop is-6-tablet is-12-mobile">
          <img src="@/assets/menu/menu-8.jpg" />
        </div>
        <div class="column is-3-desktop is-6-tablet is-12-mobile">
          <img src="@/assets/menu/menu-9.jpg" />
        </div>
        <div class="column is-3-desktop is-6-tablet is-12-mobile">
          <img src="@/assets/menu/menu-10.jpg" />
        </div>
        <div class="column is-3-desktop is-6-tablet is-12-mobile">
          <img src="@/assets/menu/menu-11.jpg" />
        </div>
        <div class="column is-3-desktop is-6-tablet is-12-mobile">
          <img src="@/assets/menu/menu-12.jpg" />
        </div>
        <div class="column is-3-desktop is-6-tablet is-12-mobile">
          <img src="@/assets/menu/menu-13.jpg" />
        </div>
        <div class="column is-3-desktop is-6-tablet is-12-mobile">
          <img src="@/assets/menu/menu-14.jpg" />
        </div>
        <div class="column is-3-desktop is-6-tablet is-12-mobile">
          <img src="@/assets/menu/menu-15.jpg" />
        </div>
        <div class="column is-3-desktop is-6-tablet is-12-mobile">
          <img src="@/assets/menu/menu-16.jpg" />
        </div>
        <div class="column is-3-desktop is-6-tablet is-12-mobile">
          <img src="@/assets/menu/menu-17.jpg" />
        </div>
        <div class="column is-3-desktop is-6-tablet is-12-mobile">
          <img src="@/assets/menu/menu-18.jpg" />
        </div>
        <div class="column is-3-desktop is-6-tablet is-12-mobile">
          <img src="@/assets/menu/menu-19.jpg" />
        </div>
        <div class="column is-3-desktop is-6-tablet is-12-mobile">
          <img src="@/assets/menu/menu-20.jpg" />
        </div>
        <div class="column is-3-desktop is-6-tablet is-12-mobile">
          <img src="@/assets/menu/menu-21.jpg" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: "MenuPage",
  mounted() {
    window.scrollTo(0, 0);
  }
};
</script>
